module.exports = __webpack_public_path__ + "media/images/canvas_og-c9307773.png";